export default "__VITE_ASSET__eb83ca7f__"